module.exports = __webpack_public_path__ + "img/avatar.051d3249.png";